import { render, staticRenderFns } from "./BookingReportSeatClassView.vue?vue&type=template&id=2609aec6&"
import script from "./BookingReportSeatClassView.vue?vue&type=script&lang=js&"
export * from "./BookingReportSeatClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2609aec6')) {
      api.createRecord('2609aec6', component.options)
    } else {
      api.reload('2609aec6', component.options)
    }
    module.hot.accept("./BookingReportSeatClassView.vue?vue&type=template&id=2609aec6&", function () {
      api.rerender('2609aec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/report/BookingReportSeatClassView.vue"
export default component.exports